import * as React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';
const Permissions = (props) => (<Svg {...props}>
    <Rect width={28} height={28} rx={8} fill={props?.fill ?? '#D7EBF8'}/>

    <Path d="M13.092 10.592a5 5 0 1 0-6.184 0 8.333 8.333 0 0 0-5.183 6.816.839.839 0 0 0 1.667.184 6.667 6.667 0 0 1 13.25 0 .833.833 0 0 0 .833.742h.092a.833.833 0 0 0 .733-.917 8.333 8.333 0 0 0-5.208-6.825ZM10 10a3.333 3.333 0 1 1 0-6.666A3.333 3.333 0 0 1 10 10Z" fill={props?.fill ?? '#3999DE'} transform="translate(6 5) scale(0.8)"/>
  </Svg>);
export default Permissions;
